<section class="pupil-exercise">
  <div *ngIf="errorMessage">
    <div>{{errorMessage}}</div>
  </div>
  <div class="task type-number">
    <h4 class="task-number bluelight_txt">Задание {{ selectedExerciseIndex + 1 }}</h4>
    <div class="task-content">
      <p class="bluelight_txt text-left" *ngIf="exercise.type == sequence && sequenceInstruction">
        {{ sequenceInstruction }}
      </p>
      <div class="question answer-group" id="question">
        <ng-katex *ngIf="isKatexFormat(exercise)" class="katex text" [equation]="exercise.text"></ng-katex>
        <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" class="question_text" [paragraph]="exercise.text| exerciseFormat"></ng-katex-paragraph>
      </div>
      <div class="input-group big answer active answer-group">
        <span class="cross-icon" (click)="clearAnswer()">
          <app-svg-icon
            [src]="crossIcon" class="svg-icon">
          </app-svg-icon>
        </span>
        <input *ngIf="!checkAnswersPerString()" type="text" name="" class="answer_input text-left" [(ngModel)]="answerString" readonly="readonly">
        <div class="buffer"></div>
        <form class="check-answer-form" *ngIf="checkAnswersPerString()">
          <input type='text' (change)="updateAnswer($event)" class='answer_input text-left'>
          <button type="button" (click)="checkAnswer()" appDisTouchmove [disabled]="!answerString"></button>
        </form>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!checkAnswersPerString()">
    <div class="keyboard">
      <div class="keyboard-container">
        <ul>
          <li class="keyboard-item" *ngFor="let button of buttons">
            <a (click)="keyboardClicked(button)" appDisTouchmove>
              {{ button }}
            </a>
          </li>
          <li class="keyboard-item" *ngIf="exercise.type == sequence">
            <a (click)="keyboardClicked(',')" appDisTouchmove>
              ,
            </a>
          </li>
          <li class="keyboard-item" *ngIf="exercise.type == sequence || exercise.type == calculation">
            <a (click)="keyboardClicked(' ')" appDisTouchmove>
              &nbsp;
            </a>
          </li>
          <li class="keyboard-item">
            <a (click)="keyboardClicked(0)" appDisTouchmove>
              0
            </a>
          </li>
          <li class="keyboard-item enter">
            <a (click)="checkAnswer()" appDisTouchmove>
              <!-- <img src="/assets/images/enter.png" alt="" /> -->
            </a>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</section>

